import { formatMarketplacePrice } from '@shared/utils/currency/format-marketplace-price.util';

export class PriceUtils {
  static formatAndRoundUpPrice(price: number, currency?: string): string {
    const normalizedCurrency = (currency ?? '').toUpperCase();

    if (normalizedCurrency === 'HUF') {
      return String(Math.round(Math.ceil(price) / 100));
    }

    let formattedPrice = price / 100;
    const decimalIndex = formattedPrice.toString().indexOf('.');
    const numOfCharactersAfterDot = formattedPrice.toString().length - decimalIndex - 1;

    if (numOfCharactersAfterDot >= 3) {
      formattedPrice = Math.ceil(formattedPrice * 100) / 100;
    }

    return formattedPrice.toFixed(2);
  }

  static formatAndRoundUpPriceWithComa(price: number, currency?: string): string {
    const normalizedCurrency = (currency ?? '').toUpperCase();

    if (normalizedCurrency === 'HUF') {
      return formatMarketplacePrice(price, 'HUF', { amountInCents: true });
    }

    const formattedPrice = Math.ceil(price) / 100;

    return formattedPrice.toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  static formatAmountWithCurrency(priceInCents: number, currency: string): string {
    return formatMarketplacePrice(priceInCents, currency, { amountInCents: true });
  }

  static roundUpToNearestWholeNumber(value: number): number {
    return Math.ceil(value);
  }
}
